import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'bb-dropdown-button',
	templateUrl: './bb-dropdown-button.component.html',
	styleUrls: ['./bb-dropdown-button.component.scss']
})

export class BbDropdownButtonComponent implements OnInit {

	@Input() icon = 'plus';
	@Input() label: string;

	showDropdown = false;

	constructor() { }

	ngOnInit() { }
}
